const d3 = require("d3");
const { DashboardVisual } = require("@/visualisation/dashboard/dashboardVisual.js");

class CurrentProjectVisual extends DashboardVisual {
    constructor(svg, currData) {
        super(svg);

        this.initChart(currData);
    }

    getBaseOpacities() {
        return [1.0, 1.0, 1.0, 1.0];
    }

    valToString(val) {
        return Math.round(val).toString();
    }

    getBaseColours() {
        return ["rgb(255, 102, 127)", "rgb(255, 210, 102)", "rgb(108, 218, 102)", "rgb(102, 188, 255)"];
    }


    initChart(currData) {

        super.initChart(this.getBaseOpacities(), this.getBaseColours(), currData.pieData);




        this.currentProjectText = this.chart.append("text").attr("text-anchor", "middle").attr("dy", ".35em").attr("y", -20).text("6 / 26").style("font-family", "Open Sans").style("font-size", "40px").style("font-weight", "600").style("fill", "rgba(74, 74, 74, 1)");

        // Add one word in the middle of the circle, with the open sans font
        this.chart.append("text").attr("text-anchor", "middle").attr("dy", ".35em").attr("y", 10).text("Projects in").style("font-family", "Open Sans").style("font-size", "17px").style("font-weight", "400").style("fill", "rgba(74, 74, 74, 1)");

        this.chart.append("text").attr("text-anchor", "middle").attr("dy", ".35em").attr("y", 30).text("execution").style("font-family", "Open Sans").style("font-size", "17px").style("font-weight", "400").style("fill", "rgba(74, 74, 74, 1)");
    
        this.updateChart(currData)
    }

    updateChart(currData) {
        super.updatePie(currData.pieData);

        var text = currData.activeProjects + " / " + currData.totalProjects;
        if(!currData.isPortfolioPlanning){
            text = currData.totalProjects;
        }
        this.currentProjectText.text(text);
    }
}

export { CurrentProjectVisual };